import { useEffect, useState } from "react";
import { useIntl, FormattedMessage } from 'react-intl';
// ui 
import { Tabs, Tab } from "baseui/tabs-motion";
import { AutomationObjectsOperatorPanelSelector, AutomationObjectsParameterPanelSelector, AutomationObjectsSystemPanelSelector, HasParameterPanel, HasSystemPanel, HasProcessPanel, HasConfigurationPanel, AutomationObjectsConfigPanelSelector, HasInsightsPanel, InsightsPanelSelector } from '../../automationObjects/automationObjectsSelector'
import { RelationsViewFlow } from '../../features/RelationsView'
import { Block } from "baseui/block";
import { useStyletron } from "baseui";
import { VscGear, VscSettings } from "react-icons/vsc";
import { Button } from "baseui/button";
import { Modal, ModalBody, ModalHeader } from "baseui/modal";
import { TiFlowSwitch } from "react-icons/ti";
import { IconEdgeDevice } from "../Devices/EdgeDevice/IconEdgeDevice";
import { useGetObjectsChildren } from "../../hooks/useGetObjectsChildren";
import { isParameterApp } from "../parameterApps";
import { UserInteractionsTimeline } from "../../features/UserInteractions";
import { getTimeRangeFromTimespan } from "../../utils/timeUtils";
import { MdInsights } from "react-icons/md";
import { LiaUserEditSolid } from "react-icons/lia";



export const DetailsView = (props: any) => {
    const data = props;
    const [css, theme] = useStyletron();
    const intl = useIntl();

    const { children, error, isLoading, isSuccess } = useGetObjectsChildren(props.resourceGroupId, props.id);
    
    const hasParameters = children?.filter(v => v !== null).filter(v => isParameterApp(v.schema));
    const hasParameterPanel = HasParameterPanel({ tag: props.schema }) && (hasParameters && hasParameters.length > 0);
    const hasSystemPanel = HasSystemPanel({ tag: props.schema });
    const hasProcessPanel = HasProcessPanel({ tag: props.schema });
    const hasConfigPanel = HasConfigurationPanel(props.schema);
    const hasInsightsPanel = HasInsightsPanel(props.schema);

    const [activeKey1, setActiveKey1] = useState<React.Key>(hasInsightsPanel ? 0 : 1);
    const [activeKey, setActiveKey] = useState<React.Key>(getView(props.defaultView));

    

    const [showConfiguration, setShowConfiguration] = useState(false);
    const [showInsights, setShowInsights] = useState(false);

    useEffect(() => {
        if (props.defaultView === 'configuration')
            setShowConfiguration(true);
    }, [props.defaultView])

    useEffect(() => {

        if (!hasSystemPanel && activeKey === '3')
            setActiveKey('0');
        if (!hasParameterPanel && activeKey === '2')
            setActiveKey('0');
        if (!hasProcessPanel && activeKey === '1')
            setActiveKey('0');
    }, [hasSystemPanel, hasParameterPanel, hasProcessPanel, hasConfigPanel, activeKey])

    const timeRange = getTimeRangeFromTimespan(90 * 24 * 60);

    return (
        <div>
            <Tabs
                activeKey={activeKey}
                onChange={({ activeKey }) => setActiveKey(activeKey)}
                activateOnFocus
                endEnhancer={
                    <>
                        
                            <Button onClick={() => setShowInsights(true)} size={'default'} kind='tertiary' shape={'circle'}>
                                💡
                            </Button>
                        
                        {hasConfigPanel &&
                            <Button onClick={() => setShowConfiguration(true)} size={'default'} kind='tertiary' shape={'circle'}>
                                <VscGear></VscGear>
                            </Button>}
                    </>
                }>
                <Tab overrides={tabStyle} title={intl.formatMessage({ id: "app", defaultMessage: "App" })}>
                    <AutomationObjectsOperatorPanelSelector tag={data.schema} state={data}></AutomationObjectsOperatorPanelSelector>
                </Tab>
                {hasProcessPanel &&
                    <Tab overrides={tabStyle} artwork={smallProcessIcon} title={intl.formatMessage({ id: "process", defaultMessage: "Process" })} >
                        <RelationsViewFlow resourceGroupId={props.resourceGroupId} objectId={props.id} relationType={'Feeds'}></RelationsViewFlow>
                    </Tab>
                }
                {hasParameterPanel &&
                    <Tab overrides={tabStyle} artwork={smallSettingsIcon} title={intl.formatMessage({ id: "parameters", defaultMessage: "Parameters" })} >
                        <AutomationObjectsParameterPanelSelector tag={data.schema} state={data}></AutomationObjectsParameterPanelSelector>
                    </Tab>
                }
                {hasSystemPanel &&
                    <Tab overrides={tabStyle} title={intl.formatMessage({ id: "devices", defaultMessage: "Devices" })}  >
                        <AutomationObjectsSystemPanelSelector tag={data.schema} state={data}></AutomationObjectsSystemPanelSelector>
                    </Tab>
                }
            </Tabs >
            {showConfiguration &&
                <Modal size={'default'} isOpen={showConfiguration} onClose={() => setShowConfiguration(false)}>
                    <ModalHeader>{intl.formatMessage({ id: "configuration", defaultMessage: "Configuration" })}</ModalHeader>
                    <ModalBody>
                        <AutomationObjectsConfigPanelSelector tag={data.schema} state={data}></AutomationObjectsConfigPanelSelector>
                    </ModalBody>
                </Modal>}
            {showInsights &&
                <Modal size={'full'} isOpen={showInsights} onClose={() => setShowInsights(false)}>
                    <ModalHeader>{intl.formatMessage({ id: "insights", defaultMessage: "Insights" })}</ModalHeader>
                    <ModalBody>
                        <Tabs
                            activeKey={activeKey1}
                            onChange={({ activeKey }) => {
                                setActiveKey1(activeKey);
                            }}
                           
                            activateOnFocus
                        >
                            {hasInsightsPanel && <Tab key={0} title={<MdInsights />}><InsightsPanelSelector modelId={data.schema} state={data}></InsightsPanelSelector></Tab>}
                            <Tab key={1} title={<LiaUserEditSolid></LiaUserEditSolid>}>
                                <UserInteractionsTimeline {...props} start={timeRange.start} end={new Date()}></UserInteractionsTimeline>
                            </Tab>
                        </Tabs>
                    </ModalBody>
                </Modal>}
        </div>
    )
}


const smallProcessIcon = () => {
    return (<TiFlowSwitch height='15px'></TiFlowSwitch>)
}
const smallSettingsIcon = () => {
    return (<VscSettings height='15px'></VscSettings>)
}

function getView(viewid?: string) {
    if (viewid) {
        switch (viewid) {
            case 'process': return 1;
            //case 'configuration': return 2;
        }
    }
    return 0;
}

const tabStyle = {
    TabPanel: {
        style: { paddingLeft: '0px', paddingRight: '0px' }
    }
}